<script>
import Icon from "./Icon.vue";

export default {
    name: "InfoBox",
    components: {
        Icon,
    }
}
</script>

<template>
    <div class="mb-8 flex items-center justify-between bg-indigo-500 rounded w-full">
        <div class="flex items-center">
            <icon name="information-outline" class="mx-4 flex-shrink-0 w-4 h-4 fill-white"></icon>
            <div class="py-4 text-white text-sm font-medium">
                <slot></slot>
            </div>
        </div>
    </div>
</template>

<style scoped>

</style>
